module.exports = __webpack_public_path__ + "img/Lapto-2-p-1600.793e0a62.png";